import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Page404Component } from 'src/app/components/page404/page404.component';
import { AddRolesComponent } from 'src/app/components/user-management/roles/addroles.component';

import { AddUsersComponent } from 'src/app/components/user-management/users/add/addusers.component';
import { EditUsersComponent } from 'src/app/components/user-management/users/edit/editusers.component';
import { ListUsersComponent } from 'src/app/components/user-management/users/list/listusers.component';

const routes: Routes = [
  { path: 'roles', component: AddRolesComponent },

  { path: 'users', component: ListUsersComponent },
  { path: 'users/add', component: AddUsersComponent },
  { path: 'users/edit/:id', component: EditUsersComponent },

  { path: '', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule { }
